var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    style: {
      color: '#fff',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)'
    }
  }, [_vm._v(" " + _vm._s(_vm.tagline) + " ")])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card rounded-lg"
  }, [_c('b-row', {
    staticClass: "justify-content-center mt-2"
  }, [_c('div', {
    staticClass: "logo text-center"
  }, [_c('img', {
    attrs: {
      "src": "/img/navbar/logo.png",
      "alt": "Logo"
    }
  })])]), _c('div', {
    staticClass: "card-body pl-5 pr-5"
  }, [_c('h3', {
    staticClass: "text-center mb-4"
  }, [_vm._v(_vm._s(_vm.$t("changePassword")))]), _c('form', {
    staticClass: "theme-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "input-label mt-3",
    attrs: {
      "for": "otp"
    }
  }, [_vm._v(_vm._s(_vm.$t("OTP")))]), _c('v-text-field', {
    attrs: {
      "type": "number",
      "id": "otp",
      "placeholder": _vm.$t('enterOTP'),
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.otp,
      callback: function ($$v) {
        _vm.otp = $$v;
      },
      expression: "otp"
    }
  }), _c('div', {
    staticClass: "text-right"
  }, [_vm.resendTimer > 0 ? _c('small', [_vm._v(" " + _vm._s(_vm.$t("resendOTP")) + " " + _vm._s(Math.floor(_vm.resendTimer / 60)) + ":" + _vm._s((_vm.resendTimer % 60).toString().padStart(2, "0")) + " ")]) : _c('a', {
    staticStyle: {
      "font-size": "13px",
      "text-decoration": "underline",
      "display": "inline-block"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.resendOtp.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("noOTPResend")) + " ")])]), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("newPassword")))]), _c('v-text-field', {
    staticClass: "password-field",
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('newPassword'),
      "type": _vm.showPassword ? 'password' : 'text',
      "append-icon": _vm.showPassword ? 'mdi-eye-off' : 'mdi-eye',
      "required": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "click:append": _vm.togglePasswordVisibility
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("confirmNewPassword")))]), _c('v-text-field', {
    staticClass: "password-field",
    attrs: {
      "id": "password1",
      "placeholder": _vm.$t('confirmNewPassword'),
      "type": _vm.showPassword1 ? 'password' : 'text',
      "append-icon": _vm.showPassword1 ? 'mdi-eye-off' : 'mdi-eye',
      "required": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "click:append": _vm.togglePasswordVisibility1
    },
    model: {
      value: _vm.confirmPassword,
      callback: function ($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  })], 1), _c('div', {
    staticClass: "pt-4 form-group text-center"
  }, [!_vm.isLoading ? [_c('b-button', {
    staticClass: "btn-primary",
    attrs: {
      "size": "lg",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("submit")))])] : _vm._e(), _vm.isLoading ? _vm._l(3, function (i) {
    return _c('b-spinner', {
      key: i,
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "label": "Small Spinner",
        "type": "grow"
      }
    });
  }) : _vm._e()], 2)]), _c('p', {
    staticClass: "pt-2",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("byContinue")) + " " + _vm._s(_vm.appName) + " "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "to": "/terms_conditions"
    }
  }, [_vm._v(_vm._s(_vm.$t("accountDetails.terms")))]), _vm._v(" " + _vm._s(_vm.$t("ofUseand")) + " "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("accountDetails.privacy")))])], 1)])], 1)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }